/**
 * @generated SignedSource<<b0aebfbdc579444d678dcd28367ed973>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EntityWithPositionInput = {
  id: string;
  position?: number | null;
};
export type LabelListSortMutation$variables = {
  positions: ReadonlyArray<EntityWithPositionInput>;
};
export type LabelListSortMutation$data = {
  readonly updateLabelPositions: boolean;
};
export type LabelListSortMutation = {
  response: LabelListSortMutation$data;
  variables: LabelListSortMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "positions"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "positions",
        "variableName": "positions"
      }
    ],
    "kind": "ScalarField",
    "name": "updateLabelPositions",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LabelListSortMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LabelListSortMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "23a530be877b25c8a6351ecded54c589",
    "id": null,
    "metadata": {},
    "name": "LabelListSortMutation",
    "operationKind": "mutation",
    "text": "mutation LabelListSortMutation(\n  $positions: [EntityWithPositionInput!]!\n) {\n  updateLabelPositions(positions: $positions)\n}\n"
  }
};
})();

(node as any).hash = "4f4f81be1ff98b9fa1711ee407b1957c";

export default node;
